module.exports = __webpack_public_path__ + "static/img/provider-jh.dd20edbb.svg";